export default __webpack_public_path__ + "static/media/favicon.720575c9.ico";